import { j as i } from "./index.es176.js";
const o = ({ isDark: l = !1, isSmall: e = !1 }) => {
  const r = l ? "#000" : "#fff", s = 32, n = 24, t = [4, 16, 28], a = [3, 12, 21];
  return /* @__PURE__ */ i.jsxs(
    "svg",
    {
      className: "bl-loader",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      width: e ? n : s,
      height: "8",
      viewBox: `0 0 ${e ? n : s} 8`,
      children: [
        /* @__PURE__ */ i.jsx(
          "circle",
          {
            fill: r,
            stroke: "none",
            cx: e ? a[0] : t[0],
            cy: "4",
            r: e ? a[0] : t[0],
            children: /* @__PURE__ */ i.jsx(
              "animate",
              {
                attributeName: "opacity",
                dur: "1s",
                values: "0;1;0",
                repeatCount: "indefinite",
                begin: "0.1"
              }
            )
          }
        ),
        /* @__PURE__ */ i.jsx(
          "circle",
          {
            fill: r,
            stroke: "none",
            cx: e ? a[1] : t[1],
            cy: "4",
            r: e ? a[0] : t[0],
            children: /* @__PURE__ */ i.jsx(
              "animate",
              {
                attributeName: "opacity",
                dur: "1s",
                values: "0;1;0",
                repeatCount: "indefinite",
                begin: "0.2"
              }
            )
          }
        ),
        /* @__PURE__ */ i.jsx(
          "circle",
          {
            fill: r,
            stroke: "none",
            cx: e ? a[2] : t[2],
            cy: "4",
            r: e ? a[0] : t[0],
            children: /* @__PURE__ */ i.jsx(
              "animate",
              {
                attributeName: "opacity",
                dur: "1s",
                values: "0;1;0",
                repeatCount: "indefinite",
                begin: "0.3"
              }
            )
          }
        )
      ]
    }
  );
};
export {
  o as default
};
//# sourceMappingURL=index.es283.js.map
